import React from 'react';

const ProfessionalBackground = () => {
  return (
    <div className="background-container">
      <div className="gradient-mesh"></div>
      <div className="gradient-overlay"></div>
      <div className="floating-particles">
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
      </div>
    </div>
  );
};

export default ProfessionalBackground;